export default __webpack_public_path__ + "static/media/twitter.c191f953.svg";